import React, { useState } from 'react';
import RadioButton from 'Components/common/RadioBtn';
import * as CONSTANTS from 'Utils/constants';
import Select from '../select';
import { HocPopupComponent } from '../hocPopupComponent';
import './setEmailNotification.scss';
import CancelSaveButton from '../CancelSaveButton';

const dayPreference = [
  { label: 'First', value: 'First' },
  { label: 'Last', value: 'Last' },
];

const SetEmailNotification = props => {
  const {
    customTitle,
    customClassName = '',
    handleChangeRadio,
    selectedEmailValues,
  } = props;

  const [showTimeZonePopup, setShowTimeZonePopup] = useState(false);
  const [timeZoneValue, setTimeZoneValue] = useState(
    selectedEmailValues.timeZone,
  );

  return (
    <div className={`set-email-container ${customClassName}`}>
      <>
        <div>
          <h5>{customTitle}</h5>
          <div className="radio-buttons">
            <RadioButton
              name="frequency"
              id="weekly"
              label="Weekly"
              value="Weekly"
              checked={
                selectedEmailValues.selectedTime === 'Weekly' ? 'checked' : ''
              }
              onChange={() => handleChangeRadio('selectedTime', 'Weekly')}
            />
            <RadioButton
              name="frequency"
              id="monthly"
              label="Monthly"
              value="Monthly"
              checked={
                selectedEmailValues.selectedTime === 'Monthly' ? 'checked' : ''
              }
              onChange={() => handleChangeRadio('selectedTime', 'Monthly')}
            />
          </div>
        </div>
      </>
      <div
        className={
          selectedEmailValues.selectedTime === 'Weekly'
            ? 'dropdowns-container'
            : 'dropdown-container-months'
        }
      >
        <div className="dropdown-with-label-day">
          {selectedEmailValues.selectedTime !== 'Weekly' && (
            <Select
              inlineLabel={false}
              label="Day"
              selectWrapperProps={{
                className: 'frequency-dropDown day-pref',
              }}
              dropdownOffset={{ top: 100 }}
              options={dayPreference}
              value={[selectedEmailValues.ordinalDay]}
              onChange={data => {
                handleChangeRadio('ordinalDay', data);
              }}
            />
          )}
          <Select
            {...(selectedEmailValues.selectedTime === 'Weekly' && {
              inlineLabel: false,
              label: 'Day',
            })}
            selectWrapperProps={{
              className: 'frequency-dropDown',
            }}
            dropdownOffset={{ top: 100 }}
            options={CONSTANTS.weekDays}
            value={[selectedEmailValues.day]}
            onChange={data => {
              handleChangeRadio('day', data);
            }}
          />
        </div>
        <span className="small-text">at</span>
        <div className="dropdown-with-label">
          <Select
            selectWrapperProps={{
              className: 'frequency-dropDown time',
            }}
            inlineLabel={false}
            label="Time"
            dropdownOffset={{ top: 100 }}
            options={CONSTANTS.time}
            value={[selectedEmailValues.time]}
            onChange={data => {
              handleChangeRadio('time', data);
            }}
          />
        </div>
        <div
          className="timezone-selected show-elipsis"
          title={selectedEmailValues.timeZone}
          onClick={() => {
            setShowTimeZonePopup(true);
          }}
        >
          {selectedEmailValues.timeZone}
        </div>
        {showTimeZonePopup && (
          <HocPopupComponent
            customClassName="time-zone-popup"
            closeClick={() => setShowTimeZonePopup(false)}
          >
            <Select
              selectWrapperProps={{
                className: 'frequency-dropDown zone-pref',
              }}
              searchInputProps={{ placeholder: 'Search' }}
              dropdownOffset={{ top: 100 }}
              enableSearch
              label="Time Zone"
              inlineLabel={false}
              options={CONSTANTS.timeZonesList}
              value={timeZoneValue}
              onChange={data => {
                setTimeZoneValue(data);
              }}
            />
            <CancelSaveButton
              handleSave={() => {
                handleChangeRadio('timeZone', timeZoneValue);
                setShowTimeZonePopup(false);
              }}
              handleCancel={() => {
                setTimeZoneValue(selectedEmailValues.timeZone);
                setShowTimeZonePopup(false);
              }}
            />
          </HocPopupComponent>
        )}
      </div>
    </div>
  );
};
export default SetEmailNotification;
